import React from "react"
import "./NewNav.css"
// import styles from "./Navabar.module.css";
import { Link, useNavigate } from "react-router-dom"
import logo from "../images/CSI-Logo.png"

const NewNav = () => {
  const [open, setOpen] = React.useState(false)
  const navigate = useNavigate()
  const dropHandler = () => {
    setOpen(!open)
  }

  function pageChangingHandler() {
    setOpen(false)
    // props.onPageChange(
    //   event.target.innerText.toLowerCase().split(" ").join("")
    // );
  }
  React.useEffect(() => {
    let i
    function Drp(n) {
      const elem = document.getElementsByClassName("menu-con")[n]
      elem.style.top = `${-1 * window.innerHeight - n * 100 - 30}px`
    }

    function Cls(n) {
      const elems = document.getElementsByClassName("menu-con")[n]
      elems.style.top = "0px"
    }
    if (open === false) {
      for (i = 0; i < 8; i++) {
        Drp(i)
      }
    } else if (open === true) {
      for (i = 0; i < 8; i++) {
        Cls(i)
      }
      setTimeout(() => {
        const menu = document.getElementById("menu")
        if (!menu.classList.contains("hidden")) {
          menu.classList.add("hidden")
        }
      }, 1800)
    }
  }, [open])
  return (
    <div className="newNav" style={{ zIndex: open ? 3 : -5 }}>
      <div
        className="navLogo"
        onClick={() => {
          navigate("/")
        }}
      >
        <img src={logo} alt="logo" />
        CSI
      </div>
      <div
        className={!open ? "menu-icon" : "menu-icon-open menu-icon hover"}
        onClick={dropHandler}
      >
        <div className="menu-bar menu-bar1" />
        <div className="menu-bar menu-bar2" />
        <div className="menu-bar menu-bar3" />
      </div>
      <div className="menu" style={{ zIndex: open ? 3 : -5 }}>
        <div
          className="menu-con"
          style={{ background: "black" }}
          onClick={pageChangingHandler}
        >
          <Link to="/">Home</Link>
        </div>
        <div
          className="menu-con"
          style={{ background: "black" }}
          onClick={pageChangingHandler}
        >
          <Link to="/team">Team</Link>
        </div>
        <div
          className="menu-con"
          style={{ background: "black" }}
          onClick={pageChangingHandler}
        >
          <Link to="/achievements">Achievements</Link>
        </div>
        <div
          className="menu-con"
          style={{ background: "black" }}
          onClick={pageChangingHandler}
        >
          <Link to="/projects">Projects</Link>
        </div>
        <div
          className="menu-con"
          style={{ background: "black" }}
          onClick={pageChangingHandler}
        >
          <Link to="/events">Events</Link>
        </div>
        <div
          className="menu-con"
          style={{ background: "black" }}
          onClick={pageChangingHandler}
        >
          <Link to="/workshops">Workshops</Link>
        </div>
        <div
          className="menu-con"
          style={{ background: "black", top: "0" }}
          onClick={pageChangingHandler}
        >
          <Link to="/gallery">Gallery</Link>
        </div>
        <div
          className="menu-con"
          style={{ background: "black", top: "0" }}
          onClick={pageChangingHandler}
        >
          <Link to="/technex">Technex</Link>
        </div>
      </div>
    </div>
  )
}

export default NewNav
